import { ConfigurationContext, DataLayerEventName } from '@news-mono/web-common'
import React, { useContext, useEffect, useState } from 'react'
import { StyledPollieRaterActionButton } from '../../buttons/PollieRaterButton/PollieRaterButton.styled'
import { PoliticianPoll, useUpsertPollData } from '../../PollieRater/helpers'
import {
    Spinner,
    StyledPollieFormContainer,
    StyledPollieInputLinesContainer,
    StyledPollieSlider,
    StyledPollieSliderContainer,
    StyledPollieSliderLabel,
    StyledPollieSliderTooltip,
    StyledPollieToolTipGrid,
} from './PollieRaterForm.styled'

export function PollieRaterForm({
    userScore,
    politician,
    refetchPollRating,
    onEvent,
}: {
    userScore: number
    politician: PoliticianPoll
    refetchPollRating: () => void
    onEvent: (event: any) => void
}) {
    const [pollieRating, setPollieRating] = useState(userScore)

    useEffect(() => {
        setPollieRating(userScore)
    }, [userScore])

    const [isLoading, setLoader] = useState(false)
    const [isSubmitted, setSubmit] = useState(false)

    const config = useContext(ConfigurationContext)

    const { mutate: updatePollRating } = useUpsertPollData(
        config.userPollServiceEndpoint,
        politician.id,
        pollieRating,
    )

    function handleRatingChange(e: React.ChangeEvent<HTMLInputElement>) {
        setPollieRating(parseInt(e.target.value))
        setSubmit(false)
    }

    function saveUserRating() {
        try {
            setLoader(true)
            updatePollRating()
            // Update user score to reflect the change after the stream has finished it's work (approx. time of 2s)
            setTimeout(() => {
                refetchPollRating()
                setLoader(false)
                setSubmit(true)
            }, 2000)

            onEvent({
                type: DataLayerEventName.pollieRatingSubmit,
                originator: 'PollieRaterForm',
                timeStamp: Date.now(),
                payload: {
                    politician: politician.name,
                    rating: pollieRating,
                    party: politician.party,
                },
            })
        } catch (err) {
            // Do nothing
            setLoader(false)
        }
    }

    return (
        <StyledPollieFormContainer>
            <StyledPollieSliderContainer>
                <StyledPollieToolTipGrid>
                    <StyledPollieSliderLabel backgroundPosition={1}>
                        <span>1</span>
                    </StyledPollieSliderLabel>
                    <StyledPollieSliderLabel backgroundPosition={10}>
                        <span>10</span>
                    </StyledPollieSliderLabel>
                    <StyledPollieSliderTooltip
                        value={pollieRating}
                        isDisabled={isLoading}
                    >
                        <span>{pollieRating}</span>
                    </StyledPollieSliderTooltip>
                </StyledPollieToolTipGrid>
                <StyledPollieInputLinesContainer>
                    {Array(19)
                        .fill('')
                        .map((_, index) => (
                            <div key={index} />
                        ))}
                </StyledPollieInputLinesContainer>

                <StyledPollieSlider
                    disabled={isLoading}
                    type="range"
                    min="1"
                    max="10"
                    backgroundPosition={pollieRating}
                    value={pollieRating}
                    onChange={handleRatingChange}
                    aria-valuemin={1}
                    aria-valuemax={10}
                    aria-valuenow={pollieRating}
                    aria-label="Pollie Rater Slider Input"
                />
            </StyledPollieSliderContainer>
            <StyledPollieRaterActionButton
                disabled={isSubmitted}
                onClick={() => !isLoading && saveUserRating()}
                aria-label="Pollie Rater Submit Button"
                type="submit"
            >
                {isLoading ? <Spinner /> : isSubmitted ? 'Submitted' : 'Submit'}
            </StyledPollieRaterActionButton>
        </StyledPollieFormContainer>
    )
}
